export default __webpack_public_path__ + "static/media/Spin general_Interactive LightMix0009.8eac6528.webp";